//@ts-strict-ignore
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import numeral from 'numeral';
import AnimatedNumber from 'react-animated-number';
import { Maybe } from '../../../graphql/schema/p4types';

const CardNumber = styled.div`
  position: absolute;
  display: inline-block;
  top: 45%;
  width: 100%;
  padding-top: -15px;
  margin: 0 auto;
  font-size: 48px;
  font-weight: 300;
  color: #333;
  background-image: none;
  line-height: inherit;
  text-align: center;
`;

type INumberWidgetProps = {
  value: number;
  valueMask?: Maybe<string>;
  color?: Maybe<string>;
  fontSize?: string;
};

const NumberWidget = ({ value, valueMask, color = undefined, fontSize = undefined }: INumberWidgetProps) => {
  const formatValue = (_value) => {
    return numeral(_value).format(valueMask);
  };

  return (
    <CardNumber style={{ color: color || undefined }}>
      <AnimatedNumber
        value={value}
        style={{
          transition: '0.8s ease-out',
          fontSize: fontSize,
          transitionProperty: 'color, opacity',
        }}
        duration={500}
        formatValue={formatValue}
      />
    </CardNumber>
  );
};

NumberWidget.propTypes = {
  value: PropTypes.number,
};
NumberWidget.defaultProps = {
  value: 0,
  fontSize: 48,
  valueMask: '0,00.00',
};

export default NumberWidget;
